import { useContext, useEffect, useState } from "react";
import { Dialog } from "@mui/material";

import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

import { DrawerContext } from "../../context/drawerContext";
import { ContextApi } from "../../context/contextApi";
import { UploadVideo } from "../../libs/inputs/uploadVideo";

import styles from './style.module.scss';

export function AddVideosAnuncio() {
    const {
        setShowInnerVideo,
        showInnerVideo,
        showUploadVideo,
        setShowUploadVideo,
        videoAnuncio,
        setVideoAnuncio,
    } = useContext(DrawerContext);

    const { 
      allCameras, 
      getCameras, 
      handleUploadVideo,
      cookies,
      getCameraForId, 
      cameraId,
      deleteVideos
    } = useContext(ContextApi);
    const [idCameraSelected, setIdCameraSelected] = useState(null);

    const { 
        videos,
     } = cameraId

    useEffect(() => {
        setTimeout(() => {
            if (cookies?.surfViewToken?.token) {
                getCameras() 
            }
        }, 2000);
    }, [cookies])

    function handleCloseInnerVideo() {
        setShowInnerVideo(false);
        setShowUploadVideo(false);
        setVideoAnuncio('');
    }

    async function handleInnerVideo() {
        handleUploadVideo(idCameraSelected, videoAnuncio);
        handleCloseInnerVideo();
        setShowUploadVideo(false);
    }

    async function getCamForId(idCam) {
        await getCameraForId(idCam);
    }

    async function deleteVideo(idCam, idVideo) {
        await deleteVideos(idCam, idVideo).then(() => getCamForId(idCam))
    }

    return (
        <Dialog
        onClose={handleCloseInnerVideo} 
        open={showInnerVideo}
        >
            <div className={styles.containerInputNewRegion}>
                {!showUploadVideo && 
                <>
                <div className={styles.boxTitleModalInputNewRegion}>
                    <span>
                        Primeiro selecione uma camera
                    </span>
                </div>
                <div className={styles.boxSelectCameras}>
                    <div className={styles.headerSelectCameras}>
                        <span>Nome da Camera</span>
                        <span>id stream</span>
                    </div>
                    {allCameras?.filter(cam => cam.ad_anuncio === true).map(camera => {
                        return (
                            <div 
                            key={camera.id} 
                            className={styles.boxLineCamerasOptions}
                            onClick={() => {
                                setIdCameraSelected(camera.id);
                                getCamForId(camera.id);
                                setShowUploadVideo(true);
                            }}
                            >
                                <span>{camera.nome_camera}</span>
                                <span>{camera.stream_id.length >= 10 ? camera.stream_id.slice(0, 10) + '...' : camera.stream_id}</span>
                            </div>
                        )
                    })}
                </div>
                </>}
                {showUploadVideo && 
                <>
                <div className={styles.boxTitleModalInputNewRegion}>
                    <span>
                        Fazer upload dos Videos
                    </span>
                </div>
                <div>
                    <div className={styles.boxInputTextNewRegion}>
                        <UploadVideo 
                        labelUploadImage='Anúncios'
                        videoAnuncio={videoAnuncio}
                        setVideoAnuncio={setVideoAnuncio}
                        allTypesImage={true}
                        />
                    </div>
                    {videos?.length >= 1 &&
                    <div className={styles.boxCurrentAds}>
                        <span>Esta camera possue {videos.length} anúncio{videos.length > 1 && 's'}</span>
                        <div>
                            {videos.map(video => {
                                return (
                                    <div>
                                        <video 
                                        className={styles.videoAnuncio}
                                        controls
                                        src={`https://surfview.com.br/staging/${video.file}`}
                                        >
                                        </video>
                                        <div className={styles.dotDivCurrentVideo}></div>
                                        <DeleteForeverIcon 
                                        className={styles.trashIcon}
                                        titleAccess='Excluir'
                                        onClick={() => deleteVideo(cameraId.id, video.id)}
                                        />
                                    </div>
                                )
                            })}
                        </div>
                    </div>}
                </div>
                <div 
                className={styles.boxBTNNewRegion}
                onClick={() => handleInnerVideo()}
                >
                    <span>
                        Enviar videos
                    </span>
                </div>
                </>}
            </div>
        </Dialog>
    )
}